// Engineer impersonation lifecycle analytics events (spec 048).
//
// Tracks engineer-side state transitions only — never includes the
// raw grant token, the engineer's email, or the impersonated user's
// PII. The `targetUserIdHash` is a 12-char SHA-256 prefix so we can
// correlate start/stop pairs in the analytics warehouse without
// surfacing the underlying user id.

import type { Network } from '@/lib/network';

export const ENGINEER_IMPERSONATION_STARTED = 'engineer_impersonation_started';
export const ENGINEER_IMPERSONATION_STOPPED = 'engineer_impersonation_stopped';

export type EngineerImpersonationStartedProperties = {
  engineerUserId: string;
  /** SHA-256(targetUserId).slice(0, 12). Never the raw target user id. */
  targetUserIdHash: string;
  network: Network;
};

export type EngineerImpersonationStoppedProperties = {
  engineerUserId: string;
  targetUserIdHash: string;
  network: Network;
  /** Why the session ended — engineer-initiated, expired, etc. */
  reason: 'engineer_stop' | 'expired' | 'network_toggle' | 'invalidated' | 'signout';
};
